/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TutorialRequestFromJSON(json) {
    return TutorialRequestFromJSONTyped(json, false);
}
export function TutorialRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tutorialId': !exists(json, 'tutorial_id') ? undefined : json['tutorial_id'],
        'tutorialFiles': !exists(json, 'tutorial_files') ? undefined : json['tutorial_files'],
        'requestedForUserId': !exists(json, 'requested_for_user_id') ? undefined : json['requested_for_user_id'],
        'requestedForDeviceId': !exists(json, 'requested_for_device_id') ? undefined : json['requested_for_device_id'],
    };
}
export function TutorialRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tutorial_id': value.tutorialId,
        'tutorial_files': value.tutorialFiles,
        'requested_for_user_id': value.requestedForUserId,
        'requested_for_device_id': value.requestedForDeviceId,
    };
}
//# sourceMappingURL=TutorialRequest.js.map